import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { withThemeAndSize } from "../withThemeAndSize/index.js";
import { cn as clsx } from "../../helpers/react.js";
import { useAnimationClass } from "../../hooks/useAnimationClass.js";
import { Body } from "./Body/index.js";
import { EmptyState } from "./EmptyState/index.js";
import { Footer } from "./Footer/index.js";
import { Header } from "./Header/index.js";
import '../../assets/index12.css';const layout = "_layout_10v41_1";
const content = "_content_10v41_12";
const left = "_left_10v41_20";
const animateIn = "_animateIn_10v41_20";
const appearLeft = "_appearLeft_10v41_1";
const animateOut = "_animateOut_10v41_23";
const disappearLeft = "_disappearLeft_10v41_1";
const right = "_right_10v41_27";
const appearRight = "_appearRight_10v41_1";
const disappearRight = "_disappearRight_10v41_1";
const s = {
  layout,
  content,
  left,
  animateIn,
  appearLeft,
  animateOut,
  disappearLeft,
  right,
  appearRight,
  disappearRight
};
const DrawerLayout = withThemeAndSize(
  forwardRef((props, ref) => {
    const {
      isOpen = false,
      className,
      theme,
      children,
      contentProps = {},
      side = "left",
      role = "complementary",
      ...restProps
    } = props;
    const { showElement, onAnimationEnd, animationClass } = useAnimationClass({
      valueToTrack: isOpen,
      animateIn: s.animateIn,
      animateOut: s.animateOut
    });
    if (!showElement) {
      return null;
    }
    return /* @__PURE__ */ jsx(
      "div",
      {
        ...restProps,
        ref,
        className: clsx(s.layout, animationClass, s[side], className),
        role,
        onAnimationEnd,
        children: /* @__PURE__ */ jsx("div", { ...contentProps, className: clsx(s.content, contentProps == null ? void 0 : contentProps.className), children })
      }
    );
  })
);
DrawerLayout.displayName = "Drawer";
const Drawer = Object.assign(DrawerLayout, {
  Header,
  Body,
  Footer,
  EmptyState
});
export {
  Drawer
};
